module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Da-Ea.b3608a0d.png";